import SettingsPanel from "./components/SettingsPanel";

export default SettingsPanel;
